import { FieldPulseApi }        from "field-pulse-js-sdk";
import { persistApiTokenAsync } from "~/helpers/cache.native";

console.log("[FieldPulse:Env]", process.env.NODE_ENV)
const FieldPulse = new FieldPulseApi({
  mode: process.env.NODE_ENV,
  token: window.localStorage ? window.localStorage.getItem("token") : null,
});

export const hasToken = () => {
  const t = FieldPulse.token();
  console.log('token', t);
  return !!(t);
};

export default FieldPulse;
